import { Component, inject } from '@angular/core';
import { RouterRepository } from '@ngneat/elf-ng-router-store';
import { map } from 'rxjs';

@Component({
  selector: 'digital-platform-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
  private routerRepository = inject(RouterRepository);

  public hideFooter$ = this.routerRepository
    .select((state) => state.state?.url)
    .pipe(
      map(
        (url) =>
          url &&
          (url.startsWith('/municipality') ||
            url.startsWith('/national-accounts'))
      )
    );
}
